// style
export const iconSize = {
	md: 'md:pr-5 py-1 w-full h-full svg-stroke cursor-pointer',
	lg: '',
}
